import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=5546d438"
import script from "./invoice-detail.ts?vue&type=script&lang=js&external"
export * from "./invoice-detail.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports